import React from "react";
import { Image, Text, View } from "react-native";
import { BillingConstants } from "@lib/utilities/Constants";
import { PAYMENT_ICON } from "../../../resources/IMAGES";
import { ids, styles } from "./styles";

export const PaymentStatusInfo = () => {
  return (
    <View style={styles.paymentDescriptionView} dataSet={{media:ids.paymentDescriptionView}}>
      <Image style={styles.paymentIcon} source={PAYMENT_ICON} dataSet={{media:ids.paymentIcon}} />
      <Text style={styles.paymentDescriptionText} dataSet={{media:ids.paymentDescriptionText}}>
        {BillingConstants.paymentDescription}
      </Text>
    </View>
  );
};
